import { useState } from "react";
import ProfileTab from "./ProfileTab";
import SecurityTab from "./SecurityTab";
import NotificationsTab from "./NotificationsTab";
import { LuUser, LuShieldCheck, LuBell } from "react-icons/lu";

export default function Settings() {
    const [currentTab, setCurrentTab] = useState("Profile");

    const tabs = [
        { name: "Profile", icon: <LuUser size={18} /> },
        { name: "Security", icon: <LuShieldCheck size={18} /> },
        { name: "Notifications", icon: <LuBell size={18} /> },
    ];

    const renderTabContent = () => {
        switch (currentTab) {
            case "Profile":
                return <ProfileTab />;
            case "Security":
                return <SecurityTab />;
            case "Notifications":
                return <NotificationsTab />;
            default:
                return null;
        }
    };

    return (
        <div className="p-4 md:p-8 bg-purple-50 min-h-screen">
            <div className="max-w-6xl mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Profile & Settings</h1>
                    <p className="text-gray-500 text-sm mt-1">
                        Manage your account details, security credentials, and system preferences.
                    </p>
                </div>

                <div className="flex flex-col lg:flex-row gap-6 md:gap-8 items-start relative w-full">
                    {/* Vertical Navigation (Sidebar) */}
                    <div className="w-full lg:w-64 flex-shrink-0 flex flex-row lg:flex-col gap-2 overflow-x-auto pb-2 lg:pb-0 scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0">
                        {tabs.map((tab) => (
                            <button
                                key={tab.name}
                                onClick={() => setCurrentTab(tab.name)}
                                className={`flex items-center gap-3 px-4 py-3.5 rounded-2xl transition-all font-semibold whitespace-nowrap outline-none
                                    ${currentTab === tab.name
                                        ? "bg-white text-violet-700 shadow-md shadow-violet-100 border border-violet-100 ring-2 ring-violet-50"
                                        : "text-gray-500 hover:bg-white/60 hover:text-gray-800 border border-transparent"
                                    }`}
                            >
                                <span className={currentTab === tab.name ? "text-violet-600" : "text-gray-400"}>
                                    {tab.icon}
                                </span>
                                {tab.name}
                            </button>
                        ))}
                    </div>

                    {/* Content Area */}
                    <div className="flex-1 min-w-0 w-full animate-in fade-in slide-in-from-bottom-4 duration-500">
                        <div className="bg-white rounded-3xl border border-gray-100 shadow-xl shadow-purple-900/5 p-6 md:p-8 lg:p-10">
                            {renderTabContent()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
